import React from 'react';
import { MapPin, Wrench } from 'lucide-react';

import { SERVICE_CATEGORIES, SWISS_CANTONS } from '../constants/categories';


const COPY = {
  en: { services: 'Service categories *', servicesHelp: 'Choose at least one service you provide.', areas: 'Service areas *', areasHelp: 'Choose at least one canton where you work.' },
  de: { services: 'Dienstleistungskategorien *', servicesHelp: 'Wählen Sie mindestens eine angebotene Dienstleistung.', areas: 'Einsatzgebiete *', areasHelp: 'Wählen Sie mindestens einen Kanton, in dem Sie arbeiten.' },
  it: { services: 'Categorie di servizio *', servicesHelp: 'Scegli almeno un servizio che offri.', areas: 'Aree di servizio *', areasHelp: 'Scegli almeno un cantone in cui lavori.' },
  fr: { services: 'Catégories de services *', servicesHelp: 'Choisissez au moins un service proposé.', areas: 'Zones de service *', areasHelp: 'Choisissez au moins un canton où vous travaillez.' },
};


export const ProfessionalServiceCoverageEditor = ({ value, onChange, language = 'en' }) => {
  const t = COPY[language] || COPY.en;
  const categories = value.categories || [];
  const areas = value.service_areas || { type: 'cantons', values: [] };
  const toggleCategory = (category) => onChange({
    ...value,
    categories: categories.includes(category) ? categories.filter((item) => item !== category) : [...categories, category],
  });
  const toggleArea = (area) => onChange({
    ...value,
    service_areas: { type: 'cantons', values: areas.values.includes(area) ? areas.values.filter((item) => item !== area) : [...areas.values, area] },
  });

  return <section className="space-y-5 border-y border-gray-200 py-5" data-testid="professional-service-coverage-editor">
    <div>
      <h3 className="flex items-center gap-2 font-semibold text-gray-900"><Wrench className="h-4 w-4 text-blue-700" />{t.services}</h3>
      <p className="mt-1 text-xs text-gray-500">{t.servicesHelp}</p>
      <div className="mt-3 grid max-h-52 grid-cols-2 gap-2 overflow-y-auto pr-1 sm:grid-cols-3">
        {SERVICE_CATEGORIES.map((category) => {
          const label = (language === 'de' ? category.de : category.en).split('(')[0].trim();
          const selected = categories.includes(category.value);
          return <button key={category.value} type="button" onClick={() => toggleCategory(category.value)} className={`min-h-10 border px-2 py-2 text-left text-xs font-medium transition-colors ${selected ? 'border-blue-700 bg-blue-700 text-white' : 'border-gray-300 bg-white text-gray-700 hover:border-blue-400'}`} data-testid={`settings-category-${category.value}`}>{label}</button>;
        })}
      </div>
    </div>
    <div>
      <h3 className="flex items-center gap-2 font-semibold text-gray-900"><MapPin className="h-4 w-4 text-blue-700" />{t.areas}</h3>
      <p className="mt-1 text-xs text-gray-500">{t.areasHelp}</p>
      <div className="mt-3 flex max-h-36 flex-wrap gap-2 overflow-y-auto">
        {SWISS_CANTONS.map((canton) => {
          const selected = areas.values.includes(canton.value);
          return <button key={canton.value} type="button" onClick={() => toggleArea(canton.value)} className={`min-h-9 border px-3 text-xs font-medium transition-colors ${selected ? 'border-red-600 bg-red-600 text-white' : 'border-gray-300 bg-white text-gray-700 hover:border-red-400'}`} data-testid={`settings-canton-${canton.value}`}>{canton.value}</button>;
        })}
      </div>
    </div>
  </section>;
};